module.exports = __webpack_public_path__ + "img/title-feature.ae49c269.png";